export default __webpack_public_path__ + "static/media/477.41caee17.png";